import React from 'react';
import { useForm } from 'react-hook-form';
import { AppName, footerContact, footerContactNum, navLinks, socialLinks } from '../constants';

// import { Link } from 'react-router-dom'
import { FaAngleRight, FaArrowRight, FaEnvelope, FaFacebook, FaInstagram, FaTiktok, FaTwitter, FaYoutube } from 'react-icons/fa';
import { NavLink } from 'react-router-dom';
import WhatsAppFab from './WhatsAppFab';

const Footer = () => {
    const {
        register, 
        formState: {errors}, 
        handleSubmit
      } = useForm({
        mode: "all",
      });

  return (
    <footer>
        <div className="col first-col">
            <h2>{AppName}</h2>
            <p>Where Things are made Wisely</p>
        </div>
        <div className="col second-col">
            <h2>Links</h2>
            {navLinks.map(link => (
                <ul key={link.id}>
                    <li><FaAngleRight /> {link.id}</li>
                </ul>    
            ))}
        </div>
        <div className="col third-col">
            <h2>Contact us</h2>
            {/* {footerContact.map(contact => (
                <ul key={contact.id}>
                    <li>{contact.text}</li>
                </ul>
            ))} */}
            <div className="contNum">
                {footerContactNum.map(msg => (
                    <ul key={msg.id}>
                        <li><div className="icon">{msg.icon}</div>{msg.text}</li>
                    </ul>
                ))}
            </div>
        </div>
        <div className="col fourth-col">
            <h2>Get Informed</h2>
            <p>Subscribe to our newsletter</p>
            <form onSubmit={handleSubmit(data => console.log(data))}>
                <FaEnvelope />
                <input 
                    type="email" 
                    placeholder='Enter your email address'
                    {...register("email", {
                        required: "Email is required",
                        pattern: {
                          value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                          message: "Email must be valid"
                        }
                      })}
                />
                <button 
                    type='submit' 
                    style={{ background: 'transparent', border: 'none', color: 'white', cursor: 'pointer', }}>
                    <FaArrowRight />
                </button>
            </form>
            <p style={{color: "red",}}>{errors.email?.message}</p>
            <div className="icons">
                {socialLinks.map(value =>(
                    <NavLink
                        key={value.id}
                        to={value.url} 
                        target='blank' 
                        style={{ color: '#fff' }}>
                            {value.icon}
                    </NavLink>
                ))}
                {/* <NavLink to='/twitter' style={{ color: '#fff' }}><FaTwitter /></NavLink> */}
            </div>
        </div>
        <WhatsAppFab />
    </footer>
  )
}

export default Footer